import React from 'react'
import ReactPlayer from 'react-player'

import { compose, withProps } from 'recompose' // eslint-disable-line import/no-extraneous-dependencies

import styles from './styles.css'

const VideoPlayer = compose(withProps({}))(({ children, ...restProps }) => (
  <div className={styles.root}>
    <ReactPlayer
      className={styles.player}
      {...restProps}
      width="100%"
      height="100%"
    />
  </div>
))

export default VideoPlayer



// WEBPACK FOOTER //
// ../source/components/VideoPlayer/index.js